import React from "react";
import "./dietPlan.css";
import "../../../page-layout.css";
import dietPlanBigImg from "../../images/plan-ishrane.jpeg";
import { Helmet } from "react-helmet";

const features = [
  "Priprema jelovnika prema tvom cilju",
  "Balans proteina, masti i ugljenih hidrata",
  "Unos tečnosti, vitamina i suplementacija",
  "Praćenje procesa tokom mesec dana",
  "Stalna komunikacija i podrška",
];

export default function DietPlan() {
  return (
    <div className="page-wrap">
      <Helmet>
        <title>Plan ishrane | Mihailo Živanović</title>
        <meta
          name="description"
          content="Personalizovan plan ishrane prilagođen tvom telu, ciljevima i zdravstvenom stanju."
        />
      </Helmet>

      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="page-hero-eyebrow">Usluge</div>
          <h1 className="page-hero-title">PLAN ISHRANE</h1>
          <p className="page-hero-desc">
            Personalizovan plan ishrane prilagođen baš tebi — tvom telu,
            ciljevima i zdravstvenom stanju. Jer nije svako isti.
          </p>
        </div>
      </div>

      <div className="service-body">
        <div className="service-inner">
          <div className="service-text-col">
            <div className="service-section">
              <div className="section-eyebrow">O usluzi</div>
              <p className="service-p">
                Svi smo individue — nemamo iste potrebe vezano za unos hrane.
                Neredovna i neizbalansirana ishrana je uzrok bezbroj
                zdravstvenih problema, od kojih mnogi ostaju neprepoznati.
              </p>
              <p className="service-p">
                Kada znamo šta ne valja unositi, već smo na dobrom putu.
                Ali i od prekomernog unosa zdravih namirnica mogu nastati
                problemi. Zato je personalizovan plan jedino pravo rešenje.
              </p>
              <p className="service-p">
                Tu sam da ti pomognem i unapredim tvoj život onoliko koliko
                je to moguće. <strong>VI STE SAMI SEBI HRAM.</strong>
              </p>
            </div>

            <div className="service-section">
              <div className="section-eyebrow">Šta uključuje</div>
              <ul className="service-feature-list">
                {features.map((f) => (
                  <li key={f}>
                    <span className="feature-dot" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>

            <div className="service-price-box">
              <span className="service-price-label">Cena paketa</span>
              <span className="service-price-value">6.000 RSD</span>
              <p className="service-price-note">
                Mesečno. Nastavak saradnje: ista cena naredni mesec.
              </p>
            </div>
          </div>

          <div className="service-img-col">
            <div className="service-img-wrap">
              <img src={dietPlanBigImg} alt="Plan ishrane" />
            </div>

            <div className="service-cta-box">
              <h3>Zainteresovan?</h3>
              <p>Poruči plan ishrane ili pošalji upit za konsultacije.</p>
              <a href="/kontakt/" className="service-cta-btn">Naruči plan</a>
              <a href="tel:+381600737363" className="service-tel-link">
                +381 60 073 7363
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="page-cta-strip">
        <div className="page-cta-strip-inner">
          <h2>SPREMAN ZA PROMENU?</h2>
          <div className="page-cta-strip-actions">
            <a href="/kontakt/" className="btn-dark">Naruči plan</a>
            <a href="tel:+381600737363" className="btn-outline">Pozovi me</a>
          </div>
        </div>
      </div>
    </div>
  );
}
